import { useState, useEffect } from 'react';

const FB_SDK_VERSION = "v16.0";
const useFacebookSDK = (appId, language = "vi", cookieConsent = false) => {
  const [loading, setLoading] = useState(false);
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    var _a;
    if (typeof window === "undefined" || !cookieConsent)
      return;
    if (typeof FB !== "undefined" && ((_a = window == null ? void 0 : window.fbAsyncInit) == null ? void 0 : _a.hasRun)) {
      setAvailable(true);
      setLoading(false);
      return;
    }
    setLoading(true);
    initializeFacebook(appId, language).then(() => setAvailable(true)).catch(() => setAvailable(false)).finally(() => setLoading(false));
  }, [appId, language, cookieConsent]);
  const xfbmlParse = () => {
    if (typeof window === "undefined")
      return;
    if (window == null ? void 0 : window.FB) {
      window.FB.XFBML.parse();
    }
  };
  const fb = typeof window !== "undefined" ? window == null ? void 0 : window.FB : void 0;
  return { loading, available, fb, xfbmlParse };
};
const initializeFacebook = async (appId, language) => {
  return new Promise((resolve, reject) => {
    (function(d, s, id) {
      var _a;
      if (d.getElementById(id)) {
        return resolve(true);
      }
      const fjs = d.getElementsByTagName(s)[0];
      const js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = `https://connect.facebook.net/${language === "en" ? "en_US" : "vi_VN"}/sdk.js#xfbml=1&version=${FB_SDK_VERSION}&appId=${appId}&autoLogAppEvents=1&status=1&cookie=1`;
      js.defer = true;
      js.onload = () => resolve(true);
      js.onerror = () => reject(new Error("Failed to load Facebook SDK"));
      (_a = fjs.parentNode) == null ? void 0 : _a.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};

export { useFacebookSDK };
